import React from "react";

const ModelContext = React.createContext({});

export const ModelProvider = ModelContext.Provider;
export const ModelConsumer = ModelContext.Consumer;
export default ModelContext;
